<script setup lang="ts"></script>

<template>
  <icon name="lucide:circle-dashed" />
</template>

<style scoped></style>
